import { z } from 'zod';
import { ZBaseIntegrationConfig } from './base.js';
export const LOYOLY_INTEGRATION_NAME = 'loyoly';
/** Company API key from the Loyoly back office (Parameters page). */
export const ZLoyolyCredentials = z.object({
    apiKey: z.string().min(1),
});
export const ZLoyolySettings = z.object({
    showPointsEstimation: z.boolean().optional(),
    allowPointsRedemption: z.boolean().optional(),
});
export const ZLoyolyExternalData = z.object({
    campaigns: z
        .array(z.object({
        id: z.number(),
        name: z.string(),
        earningRatio: z.number().optional(),
        unrenderedDetails: z.string().optional(),
    }))
        .optional(),
    redemptionOptions: z
        .array(z.object({
        id: z.union([z.string(), z.number()]),
        name: z.string(),
        pointsCost: z.number(),
        discountAmount: z.number().optional(),
        discountPercentage: z.number().optional(),
        discountType: z.string().optional(),
        discountRateCents: z.number().optional(),
        currency: z.string().optional(),
        variantId: z.string().optional(),
        cartMinimum: z.number().optional(),
        description: z.string().optional(),
    }))
        .optional(),
    lastSyncedAt: z.iso.datetime().optional(),
});
export const ZLoyolyIntegrationConfig = ZBaseIntegrationConfig.extend(z.object({
    integrationName: z.literal(LOYOLY_INTEGRATION_NAME),
    category: z.literal('loyalty'),
    credentials: ZLoyolyCredentials,
    settings: ZLoyolySettings,
    externalData: ZLoyolyExternalData.optional(),
}).shape);
//# sourceMappingURL=loyoly.js.map